import posthog from "posthog-js";
const TOKEN = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? "https://us.i.posthog.com";
let initialized = false;
export function initAnalytics() {
    if (initialized || !TOKEN)
        return;
    posthog.init(TOKEN, {
        api_host: HOST,
        // Cookieless: nothing persisted between sessions. Every visit is a new
        // anonymous visitor — same identity model as Plausible. See /terms.
        persistence: "memory",
        autocapture: false,
        capture_pageview: false, // handled manually in App.tsx for SPA routes
        capture_pageleave: false,
        disable_session_recording: true,
        disable_surveys: true,
        respect_dnt: true,
        loaded: (ph) => {
            ph.register({ app: "uxrubric" });
        },
    });
    initialized = true;
}
export function capturePageview(path) {
    if (!initialized)
        return;
    posthog.capture("$pageview", { $current_url: window.location.origin + path });
}
export function track(event, props) {
    if (!initialized)
        return;
    posthog.capture(event, props);
}
